import { useComponent } from '@/utils/utils';
import Component from './index.vue';

export function registryMConfirm(Vue) {
  Vue.prototype.$mconfirm = function (data) {
    openConfirm(data);
  };
}

export function openConfirm(data) {
  useComponent(Component, data).$mount();
}
